import React, { useCallback, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { getAllProductCategories } from '../../../../api/action/products';
import { academyLogger } from "utils/logger";

const OurCategories = () => {
    const companyPrimaryId = useSelector((state) => state.companyReducer.company.primaryId);
    const dispatch = useDispatch();
    const [products, setProducts] = useState([]); // State to store the fetched products
    const navigate = useNavigate(); // Initialize useNavigate

    const fetchProducts = useCallback(async (company) => {
        try {
            const res = await dispatch(getAllProductCategories(company));
            if (res && Array.isArray(res)) {
                setProducts(res); // Set the fetched products to state
            }
        } catch (error) {
            academyLogger.error("Error fetching products:", error);
        }
    }, [dispatch]);

    const handleNext = (primaryId) => {
        navigate('/product', { state: { primaryId } }); // Pass primaryId as state
    };


    useLayoutEffect(() => {
        fetchProducts(companyPrimaryId);
    }, [companyPrimaryId, fetchProducts]);

    return (
        <section className="bg-gray-100 py-16" style={{ fontFamily: "'Inter', sans-serif" }}>
            <div className="container mx-auto px-4">
                <div className="flex justify-between items-center mb-8">
                    <h2 className="text-3xl font-bold text-gray-800 hover:underline hover:decoration-4 hover:decoration-emerald-500 transform hover:scale-105 transition-transform duration-300">
                        Our Choices
                    </h2>

                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {/* Dynamically render products (max 4 items per row) */}
                    {products.slice(0, 4).map((product) => (
                        <div
                            key={product.primaryId}
                            className="bg-white p-6 shadow-lg text-center relative rounded-lg hover:shadow-xl transition-shadow duration-300"
                        >
                            {/* Image */}
                            <img
                                src={product.imageURL || "https://via.placeholder.com/150"} // Fallback image if imageURL is null
                                alt={product.name}
                                className="w-full h-48 object-cover mb-4 rounded-lg"
                            />
                            <div className="text-xl font-bold text-emerald-600 mb-4">
                                {product.name}
                            </div>
                            <div className="text-gray-600 mb-4">
                                <p className="text-lg">{product.description || "Affordable and convenient spaces"}</p>
                            </div>
                            <button
                                onClick={() => handleNext(product.primaryId)}
                                className="bg-emerald-600 text-white px-6 py-3 font-semibold hover:bg-emerald-700 transition duration-300 rounded-lg shadow-lg hover:shadow-xl"
                            >
                                View Details
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default OurCategories;
